module.exports = __webpack_public_path__ + "img/keyboard_Z.cad2e187.png";